export default function initCompanyInfo() {
    const companyInfoBlock = document.querySelector('.company-info-block');

    if (companyInfoBlock) {
        const checkbox = companyInfoBlock.querySelector('.company-info-checkbox');
        const saveButton = companyInfoBlock.querySelector('.submit');
        const form = companyInfoBlock.querySelector('.axios');
        const observeInputs = companyInfoBlock.querySelectorAll('.company-info-observe-input');

        let emptyFields = 0;
        let totalFields = 0;

        if (checkbox) {
            checkbox.addEventListener('change', () => {
                const message = companyInfoBlock.querySelector('.general-success');

                if (message) {
                    message.remove();
                }

                for (const el of observeInputs) {
                    el.classList.remove('invalid');

                    const error = el.parentNode.querySelector('.input-error');
                    if (error) {
                        error.remove();
                    }
                }

                try {
                    axios.post('/wp-json/api/update-user-as-company', new FormData(form), {headers: {'Content-Type': 'multipart/form-data'}});
                } catch (error) {
                    console.log(error);
                }
            });
        }

        for (const el of observeInputs) {
            el.addEventListener('input', () => {
                saveButton.classList.remove('d-none');
            });

            totalFields++;

            if (el.value.trim() === '') {
                emptyFields++;
            }
        }

        if (emptyFields === totalFields) {
            saveButton.classList.remove('d-none');
        }
    }
}
